import React from "react";
import T from "prop-types";
import { translateProps } from "MODULES/shared/decorators";
import { withShipment } from "MODULES/OutgoingShipments/decorators";
import { StatusTag } from "MODULES/shared/components";
import { QC_HOLD } from "MODULES/inventories/constants";

export function QCHold({ hold }) {
  return hold && <StatusTag title="QC Hold" icon="pause" display="danger" />;
}

QCHold.propTypes = { hold: T.bool.isRequired };

const withProps = translateProps(({ shipment }) => ({
  hold: shipment.getIn(["inventory", "qc_status"]) === QC_HOLD
}));

export default withShipment(withProps(QCHold));



// WEBPACK FOOTER //
// ./app/modules/OutgoingShipments/components/Detail/Warnings/QCHold.jsx